import React, { useMemo } from "react";

import { Form } from "affinityForm";
import { ExecuteButton } from "affinityForm/components/executeButton";
import { InputField } from "affinityForm/fields";
import { CheckboxGroupField } from "affinityForm/fields/checkboxGroup";
import { TextareaField } from "affinityForm/fields/textarea";
import { ButtonVariants, NavigateButton } from "affinityUI/elements/button";
import { Card } from "affinityUI/elements/card";
import { ButtonGroup, DataEntryGroup } from "affinityUI/form/components";

import { PermissionGroupRecord } from "../types";

export const RoleForm: React.FC<{ permissionGroups: PermissionGroupRecord[] }> = ({ permissionGroups }) => {
  const permissionOptions = useMemo(
    () => permissionGroups.map(({ id, description }) => ({ id, label: description })),
    [permissionGroups]
  );
  return (
    <Card data-testid="role-form">
      <Form>
        <DataEntryGroup title="Role" id="role">
          <InputField name="name">Role name</InputField>
          <TextareaField name="description">Description</TextareaField>
        </DataEntryGroup>
        <DataEntryGroup
          title="User permissions"
          description="Manage user access to the dashboard by setting permissions."
          id="user-permissions"
        >
          <CheckboxGroupField name="permissionGroups" options={permissionOptions}>
            User actions
          </CheckboxGroupField>
        </DataEntryGroup>
        <ButtonGroup>
          <NavigateButton to="../.." variant={ButtonVariants.SECONDARY}>
            Cancel
          </NavigateButton>
          <ExecuteButton>Continue to confirmation</ExecuteButton>
        </ButtonGroup>
      </Form>
    </Card>
  );
};
